import { observable, action, runInAction, toJS } from 'mobx'
import { refreshToken } from '../api'

class AuthStore {
    @observable public username: string = ''
    @observable public roles: string[] = []

    constructor() {
        runInAction(() => {
            this.username = localStorage.getItem('username') || ''
            this.roles = JSON.parse(localStorage.getItem('roles') || '[]')
        })
    }

    @action
    public clear() {
        localStorage.clear()
        this.username = ''
        this.roles = []
    }

    get islogin(): boolean {
        const token = localStorage.getItem('token')
        const expire = localStorage.getItem('expire')
        const now: number = Date.now()
        if (token && expire) {
            if (parseInt(expire, 0) - now > 60000) {
                return true
            }
        }
        return false
    }

    get isPrivileged(): boolean {
        return this.roles.indexOf('privileged viewer') !== -1
    }

    @action
    public loginSuccess(username: string, roles: string[], token: string) {
        this.username = username
        this.roles = roles
        localStorage.setItem('username', username)
        localStorage.setItem('token', token)
        localStorage.setItem('roles', JSON.stringify(roles))
        const expire = Date.now() + 1000 * 60 * 60 * 12
        localStorage.setItem('expire', expire + '')
    }

    @action
    public clearUserInfo() {
        localStorage.clear()
        this.username = ''
        this.roles = []
    }

    public allowAccess(roles: string[] | string) {
        const rolesArr: string[] = toJS(this.roles)
        if (typeof roles === 'string') {
            roles = roles.split(',')
        }
        return this.islogin && roles.filter(role => rolesArr.includes(role)).length > 0
    }

    public selectDefaultPath() {
        if (this.allowAccess('submitter')) {
            return '/upload'
        } else if (this.allowAccess('approver')) {
            return '/approve'
        } else {
            return '/search'
        }
    }

    @action
    public async refreshToken() {
        const result: any = await refreshToken()
        if (result.code === 0) {
            const { username, roles, token } = result
            this.username = username
            this.roles = roles
            localStorage.setItem('username', username)
            localStorage.setItem('token', token)
            localStorage.setItem('roles', JSON.stringify(roles))
            const expire = Date.now() + 1000 * 60 * 60
            localStorage.setItem('expire', expire + '')
        }
    }
}

export default AuthStore
